import { render, staticRenderFns } from "./CreateOrEditSaleHeader.vue?vue&type=template&id=b9ef8de8&scoped=true&"
import script from "./CreateOrEditSaleHeader.vue?vue&type=script&lang=js&"
export * from "./CreateOrEditSaleHeader.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrEditSaleHeader.vue?vue&type=style&index=0&id=b9ef8de8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ef8de8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VDialog,VForm,VIcon,VRow,VTextField})
